<template>
  <div class="headercomponent">
    <div class="headcontainer">
      <div class="logoleft cont">
        <a
          href="https://forbes.hu"
          target="_blank"
          title="forbes.hu"
          class="forbeslogo"
        > <img
            alt="Forbes"
            src="../assets/images/forbes-head.svg"
          ></a>
        <a
          href="https://mvuk.hu"
          target="_blank"
          title="MVÜK weboldal"
          class="mvuklogo"
        ><img
            alt="Mvük"
            src="../assets/images/mvuk-logo-head.png"
          ></a>
      </div>
      <div class="tam cont">
        Támogatói tartalom
      </div>
      <div class="social cont">
        <a
          href="https://www.facebook.com/sharer/sharer.php?u=https%3A//forbes.hu/extra/milyen-a-21.szazadi-vezeto/"
          target="_blank"
          title="Megosztás a Facebookon"
          class="facebook share"
        ><img
            alt="Facebook"
            src="../assets/images/facebook-icon.svg"
          >
        </a>
        <a
          href="https://www.instagram.com/forbeshungary/"
          target="_blank"
          title="Forbes az Instagramon"
          class="instagram share"
        ><img
            alt="Instagram"
            src="../assets/images/instagram-icon.svg"
          >
        </a>
        <a
          href="https://twitter.com/home?status=https%3A//forbes.hu/extra/milyen-a-21.szazadi-vezeto/"
          target="_blank"
          title="Megosztás a Twitteren"
          class="twitter share"
        ><img
            alt="Twitter"
            src="../assets/images/twitter-icon.svg"
          >
        </a>
      </div>
      <div class="mobilemenu">
        <div
          class="opener"
          v-on:click="menu"
        >
          <div class="bars">

          </div>
        </div>
        <div class="cont">
          <a
            href="https://www.facebook.com/sharer/sharer.php?u=https%3A//forbes.hu/extra/milyen-a-21.szazadi-vezeto/"
            target="_blank"
            title="Megosztás a Facebookon"
            class="facebook share"
          ><img
              alt="Facebook"
              src="../assets/images/facebook-icon.svg"
            >
          </a>
          <a
            href="https://www.instagram.com/forbeshungary/"
            target="_blank"
            title="Forbes az Instagramon"
            class="instagram share"
          ><img
              alt="Instagram"
              src="../assets/images/instagram-icon.svg"
            >
          </a>
          <a
            href="https://twitter.com/home?status=https%3A//forbes.hu/extra/milyen-a-21.szazadi-vezeto/"
            target="_blank"
            title="Megosztás a Twitteren"
            class="twitter share"
          ><img
              alt="Twitter"
              src="../assets/images/twitter-icon.svg"
            >
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Headercomponent',
  methods: {
    menu () {
      document.querySelector('.mobilemenu .cont').classList.toggle('show')
      document.querySelector('.mobilemenu').classList.toggle('open')
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a {
  text-decoration: none;
}
.headercomponent {
  position: relative;
  z-index: 2;
  background-color: #fff;
}
.logoleft {
  height: 100%;
  display: flex;
  flex-wrap: nowrap;
  -ms-grid-column: 1;
  -ms-grid-row-align: center;
}
.headcontainer {
  max-width: 1460px;
  width: 100%;
  display: grid;
  display: -ms-grid;
  margin: 0 auto;
  grid-template-columns: 1fr auto 1fr;
  -ms-grid-columns: 1fr auto 1fr;
  grid-template-rows: 65px;
  -ms-grid-rows: 65px;
  align-items: center;
}
.forbeslogo,
.mvuklogo {
  height: 100%;
  justify-content: center;
  align-items: center;
  display: flex;
  width: fit-content;
  padding: 0 20px;
}
.forbeslogo {
  background-color: #42475c;
  margin-right: 5px;
}
.forbeslogo img {
  height: 25px;
  margin-top: 9px;
}
.mvuklogo img {
  height: 51px;
}
.tam {
  -ms-grid-column: 2;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 14px;
  letter-spacing: 0.5px;
  -ms-grid-row-align: center;
}
.social,
.tam {
  padding-top: 10px;
}
.social {
  -ms-grid-column: 3;
  justify-self: end;
  -ms-grid-column-align: end;
  -ms-grid-row-align: center;
}
.social a {
  margin: 0 12px;
}
.social .share img,
.mobilemenu .share img {
  height: 23px;
}
.social .share img:hover,
.mobilemenu .share img:hover {
  transform: scale(1.2);
}
.mobilemenu {
  display: none;
}
@media screen and (max-width: 550px) {
  .social {
    display: none;
  }
  .mobilemenu {
    display: initial;
    justify-self: end;
    -ms-grid-column-align: end;
    padding: 8px 20px 0 0;
  }
  .opener {
    position: relative;
    cursor: pointer;
    height: 35px;
    display: flex;
    align-items: center;
  }
  .bars {
    background-color: #42475c;
    width: 30px;
    height: 3px;
  }
  .bars:before,
  .bars:after {
    content: "";
    height: 3px;
    width: 30px;
    display: block;
    position: absolute;
    background-color: #42475c;
  }
  .bars:before {
    top: 8px;
  }
  .bars:after {
    bottom: 8px;
  }
  .open .bars {
    background-color: transparent;
  }
  .open .bars:before {
    transform: rotate(-45deg) translate(-6px, 4px);
  }
  .open .bars:after {
    transform: rotate(45deg) translate(-7px, -5px);
  }
  .mobilemenu .cont {
    display: none;
  }
  .mobilemenu .cont.show {
    display: flex;
    position: absolute;
    top: 65px;
    left: 0px;
    width: calc(100% - 20px);
    background-color: #fff;
    padding: 20px 10px;
    justify-content: center;
  }
  .share {
    margin: 0 15px;
  }
  .headcontainer {
    grid-template-columns: auto auto auto;
    -ms-grid-columns: auto auto auto;
  }
}
@media screen and (max-width: 450px) {
  .headcontainer {
    grid-template-columns: auto auto;
    -ms-grid-columns: auto auto;
    grid-template-rows: 65px auto;
    -ms-grid-rows: 65px auto;
  }
  .logoleft {
    grid-column: 1/2;
    -ms-grid-column: 1;
    grid-row: 1/2;
    -ms-grid-row: 1;
  }
  .tam {
    grid-column: 1/3;
    -ms-grid-column-span: 3;
    grid-row: 2/3;
    -ms-grid-row: 2;
    justify-self: center;
    -ms-grid-column-align: center;
    padding: 5px 0;
  }
  .mobilemenu {
    grid-column: 2/3;
    -ms-grid-column: 2;
    grid-row: 1/2;
    -ms-grid-row: 1;
    padding: 0 20px 0 0;
  }
  .forbes {
    margin-right: 0px;
  }
  .mvuklogo {
    padding: 0 15px;
  }
}
</style>
